export default "__VITE_ASSET__e_qsl$jA__"